import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";


const Recommandations = () => {
    const [recommendations, setRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchRecommendations();
    }, []);

    const fetchRecommendations = async () => {
        setLoading(true);

        const {
            data: { user },
        } = await supabase.auth.getUser();

        if (!user) {
            setRecommendations([]);
            setLoading(false);
            return;
        }

        const { data, error } = await supabase
            .from("bill_recommendations")
            .select("*")
            .eq("user_id", user.id)


        if (error) {
            console.error("Error fetching recommendations:", error.message);
        } else {
            setRecommendations(data || []);
        }

        setLoading(false);
    };

    if (loading) {
        return <div className="text-center my-5">Loading recommendations...</div>;
    }

    if (recommendations.length === 0) {
        return <div className="text-center my-5">No recommendations found.</div>;
    }

    return (
        <div className="container" style={{ marginTop: '150px' }}>
            <h2 className="mb-4 text-center">Recommended Items Near You</h2>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>Item</th>
                            <th>Actual Price</th>
                            <th>Recommended Price</th>
                            <th>Estimated Savings</th>
                            <th>Store Name</th>
                            <th>Store Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recommendations.map((rec) => (
                            <tr key={rec.id}>
                                <td>{rec.item}</td>
                                <td>${rec.actual_price.toFixed(2)}</td>
                                <td>${rec.recommended_price.toFixed(2)}</td>
                                <td>${rec.estimated_savings.toFixed(2)}</td>
                                <td>{rec.store_name}</td>
                                <td>{rec.store_address}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Recommandations;
